import React, { Fragment } from "react";
import moment from "moment";
import * as utilities from "../../utilities/utils";
import { CLAIMTYPE, CLAIMTYPE_FR } from "../../App.config";

const AirCaseDetailComponent = (props) => {
  return (
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-body">
          <table className="table table-striped">
            <thead></thead>
            <tbody>
              {Array.isArray(props.caseInfo.caseDetail) && props.caseInfo.caseDetail.length
                ? props.caseInfo.caseDetail.map((status, index) => (
                  <Fragment key={`status-${index}`}>
                    <tr>
                      <td>{props.context.t("CurrentActivity.Name.Text")}</td>
                      <td>
                        {status.firstName + " " + status.lastName}
                      </td>
                    </tr>
                    <tr>
                      <td>{props.context.t("AIR.Location.Text")}</td>
                      <td>
                        {status.location ? status.location : "-"}
                      </td>
                    </tr>
                    <tr>
                      <td>{props.context.t("AIR.CaseManager.Text")}</td>
                      <td>{status.managedBy}</td>
                    </tr>
                    <tr>
                      <td>{props.context.t("AIR.DateAirSubmitted.Text")}</td>
                      <td>
                        {status.dateAIRSubmitted ? moment(status.dateAIRSubmitted).format("MMM DD YYYY") : "-"}
                      </td>
                    </tr>
                    <tr>
                      <td>{props.context.t("AIR.OpenOrClosed.Text")}</td>
                      <td>
                        {
                          (props.selectedLanguage == "en-US") ?
                            (status.isAIRCaseOpen ? "Open" : "Closed")
                            :
                            (status.isAIRCaseOpen ? "Ouvert" : "Fermé")
                        }
                      </td>
                    </tr>
                    <tr>
                      <td>{props.context.t("AIR.ClaimType.Text")}</td>
                      <td>
                        {
                          (props.selectedLanguage == "en-US") ?
                            CLAIMTYPE[status.claimTypeAIR] : CLAIMTYPE_FR[status.claimTypeAIR]
                        }
                      </td>
                    </tr>
                    <tr>
                      <td>{props.context.t("AIR.DateOfIncident.Text")}</td>
                      <td>
                        {status.dateOfIncident ? moment(status.dateOfIncident).format("MMM DD YYYY") : "-"}

                      </td>
                    </tr>
                    <tr>
                      <td>{props.context.t("AIR.DateOfLostBegan.Text")}</td>
                      <td>
                        {status.dateLostTimeBegan ? moment(status.dateLostTimeBegan).format("MMM DD YYYY") : "-"}
                      </td>
                    </tr>
                    <tr>
                      <td>{props.context.t("AIR.EmployeeReturnToWork.Text")}</td>
                      <td>
                        {status.dateEmployeeReturnedToWork ? moment(status.dateEmployeeReturnedToWork).format("MMM DD YYYY") : "-"}


                      </td>
                    </tr>
                    <tr>
                      <td>{props.context.t("AIR.ReturnToWorkStatus.Text")}</td>
                      <td>
                        {status.rtwAIRStatus ? status.rtwAIRStatus : "-"}

                      </td>
                    </tr>
                    <tr>
                      <td>{props.context.t("AIR.FileStatus.Text")}</td>
                      <td>
                        {status.airFileStatus ? status.airFileStatus : "-"}
                      </td>
                    </tr>
                    <tr>
                      <td>{props.context.t("AIR.ClaimStatus.Text")}</td>
                      <td>
                        {status.airClaimStatus ? status.airClaimStatus : "-"}
                      </td>
                    </tr>
                    <tr>
                      <td>{props.context.t("AIR.NextActionAndFollowUpDate.Text")}</td>
                      <td>
                        {status.nextAction ? status.nextAction : "-"}
                        {" "}
                        {status.followUpDate ? moment(status.followUpDate).format("MMM DD YYYY") : "-"}

                      </td>
                    </tr>
                    <tr>
                      {/* //status.hrs */}
                      <td>{props.context.t("AIR.ModifiedHours.Text")}</td>
                      <td>
                        {status.modifiedHours?status.modifiedHours:"-"}
                        {/* {"-"} */}
                      </td>
                    </tr>
                    <tr>
                      <td>{props.context.t("AIR.Notes.Text")}</td>
                      <td>
                        {status.notes || "-"}
                      </td>
                    </tr>
                  </Fragment>
                ))
                : null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default AirCaseDetailComponent;
